import {type InputFormState} from './types'

export const DEFAULT_FORM_STATE: InputFormState = {
  totalTransactions: 30,
  incomingDomesticWires: 2,
  outgoingDomesticWires: 2,
  incomingInternationalWires: 1,
  outgoingInternationalWires: 1,
  foreignCurrencyInternationalWires: 0,
  achTransactions: 0,
}

export const FALLBACK_FORM_STATE: InputFormState = {
  totalTransactions: null,
  incomingDomesticWires: null,
  incomingInternationalWires: null,
  outgoingDomesticWires: null,
  outgoingInternationalWires: null,
  foreignCurrencyInternationalWires: null,
  achTransactions: null,
}
